import { USER_PATH } from '@/constants';

export const USER_LIST_PATH = "list";

export const getUserListUrl = () => `/${USER_PATH}/${USER_LIST_PATH}`